import { rest } from "msw";
import { apiUrl } from "features/configure";
import ecoscanMockData from "./data/MockEcoScan";

const getEcoScanLineChart = rest.post(
  `${apiUrl}/api/ecoscan/:entityName/lineChart`,
  (req, res, ctx) => {
    const { page } = req.body;
    return res(ctx.status(200), ctx.json(ecoscanMockData.lineChart[page]));
  }
);

const getEcoScanTableData = rest.post(
  `${apiUrl}/api/ecoscan/:entityName/table`,
  (req, res, ctx) => {
    return res(ctx.status(200), ctx.json(ecoscanMockData.tableData));
  }
);

export const ecoScanMocks = [getEcoScanLineChart, getEcoScanTableData];
